import { render, staticRenderFns } from "./ModalDoctorMultiple.vue?vue&type=template&id=638211c8&"
import script from "./ModalDoctorMultiple.vue?vue&type=script&lang=js&"
export * from "./ModalDoctorMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports